var map = {
	"./1.svg": 47702,
	"./2.svg": 60661,
	"./3.svg": 15732,
	"./4.svg": 47355,
	"./5.svg": 5386,
	"./6.svg": 31385,
	"./7.svg": 65992,
	"./8.svg": 24143,
	"./9.svg": 61566
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3473;